import sessionStorageService from './sessionStorageService';

export default sessionStorageService;
